/**
 * V2.0.54 — Scroll-to-top on route change.
 *
 * React Router does NOT reset the scroll position on `<Link>` clicks, so
 * navigating from the bottom of one page to the top of another loads the
 * destination scrolled mid-way. This component listens for pathname
 * changes and resets the document scroll to (0, 0).
 *
 * Mount once near the top of the BrowserRouter (it renders nothing).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
